import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import testi from '../assets/imgs/testimonials.webp'
import img from '../assets/imgs/m1 (1).webp'
import img2 from '../assets/imgs/m1 (2).webp'
import img3 from '../assets/imgs/m1 (3).webp'
import img4 from '../assets/imgs/m1 (4).webp'
import img5 from '../assets/imgs/m1 (5).webp'
import img6 from '../assets/imgs/m1 (6).webp'

const testimonials = [
    {
        name: "Michael",
        company: "MDS Manufacturing",
        image: img,
        text: "Purchasing a plot from this company was a smooth and transparent process. The team guided me through every step, making sure all my concerns were addressed."
    },
    {
        name: "Diane",
        company: "ABC Rentals",
        image: img2,
        text: "I found the perfect plot for my dream home thanks to their helpful and knowledgeable staff. The process was straightforward and hassle-free."
    },
    {
        name: "Allison",
        company: "Grand Party Rental",
        image: img3,
        text: "From the initial consultation to finalizing the paperwork, the entire experience was seamless. I am extremely satisfied with the service and the plot I purchased."
    },
    {
        name: "Allison",
        company: "Grand Party Rental",
        image: img4,
        text: "Their team provided excellent guidance and made the plot buying process easy. I'm very happy with my investment and the support I received along the way."
    },
    {
        name: "Allison",
        company: "Grand Party Rental",
        image: img5,
        text: "They made sure every detail was taken care of, and their customer service exceeded my expectations. I highly recommend them for anyone looking to buy land."
    }
];

const Testimonials = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000
    };

    return (

        <>

            <div className='testi-hero-sec'>
            <img src={testi} loading="lazy"></img>
            </div>

            <div className="testimonial-section">
                <div className="testimonial-heading">
                    <h2>What Our Customers Are Saying</h2>
                    <p>See what our satisfied clients have to say about their experience with us.</p>
                </div>

                <Slider {...settings} className="testimonial-slider">
                    {testimonials.map((testimonial, index) => (
                        <div className="testimonial-card" key={index}>
                            <div className="testimonial-content">
                                <img src={testimonial.image} loading="lazy" alt={testimonial.name} />
                                <div className="testimonial-text">
                                    <p>{testimonial.text}</p>
                                    <h4>{testimonial.name}</h4>
                                    <span>{testimonial.company}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

        </>
    );
};

export default Testimonials;
